import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { font, palette } from 'styled-theme';
import { ifProp } from 'styled-tools';

const StyledInput = styled.input`
  // border: solid 2px ${ifProp('invalid', palette('primary', 1), 'transparent')};
  border: none;
  // color: ${ifProp('invalid', palette('primary', 1), palette('grayscale', 0))};
  color: gray;
  // font-family: ${font('primary')}, ${font('secondary')};
  background: ${palette('white', 0)};
  // padding: 0rem 1rem;
  // border-radius: 5px;
  box-sizing: border-box;
  display: block;
  text-align: left;
  // line-height: 2;
  font-size: 1.2rem;
  width: 100%;
  outline: 0;
`;

const Input = ({ value, invalid, ...props }) => {
  return (
    <StyledInput
      value={value}
      // onChange={(e) => onChange(e.target.value)}
      invalid={invalid}
      {...props}
    />
  );
};

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  invalid: PropTypes.bool,
};

Input.defaultProps = {
  value: '',
  onChange: () => {},
  invalid: false,
};

export default Input;
